// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import "izitoast/dist/css/iziToast.min.css";
// import 'izitoast/dist/css/iziToast.min.css'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "flatpickr/dist/flatpickr.css";
import "vue-search-select/dist/VueSearchSelect.css";

import App from "./App";
// import BootstrapVue from 'bootstrap-vue'
import BootstrapVue from "bootstrap-vue";
import ToggleButton from "vue-js-toggle-button";
import VCalendar from "v-calendar";
import VeeValidate from "vee-validate";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import VueIziToast from "vue-izitoast";
import VueMoment from "vue-moment";
import VueQuillEditor from "vue-quill-editor";
import VueSocketio from "vue-socket.io";
import VueSweetalert2 from "vue-sweetalert2";
import VueTheMask from "vue-the-mask";
import flatPickr from "vue-flatpickr-component";
import fullCalendar from "vue-fullcalendar";
import money from "v-money";
import router from "./router";
import socketio from "socket.io-client";
// import Spinner from 'bootstrap-vue/esm/components/spinner'

// import WebCam from 'vue-web-cam'



// todo
// cssVars()
Vue.use(BootstrapVue);
// Vue.use(Spinner)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields"
});
Vue.use(VueIziToast);
Vue.use(ToggleButton);
Vue.use(money, { precision: 4 });
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);
Vue.use(VueQuillEditor);
Vue.use(flatPickr);
Vue.use(VueMoment);
Vue.use(fullCalendar);
Vue.use(
  VueSocketio,
  socketio("https://api.paradigmfitnessindonesia.com", { path: "/ws" })
);
Vue.use(VCalendar, {
  componentPrefix: "vc"
});

Vue.filter("toRupiahWithDecimal", function(value) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
});

Vue.filter("toRupiah", function(value) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
});

// Vue.use(WebCam)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App
  }
});
